var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1540_6805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 16C22.9467 16 25.3334 13.6133 25.3334 10.6666C25.3334 7.71998 22.9467 5.33331 20 5.33331C17.0534 5.33331 14.6667 7.71998 14.6667 10.6666C14.6667 13.6133 17.0534 16 20 16ZM8.00004 13.3333V10.6666C8.00004 9.93331 7.40004 9.33331 6.66671 9.33331C5.93337 9.33331 5.33337 9.93331 5.33337 10.6666V13.3333H2.66671C1.93337 13.3333 1.33337 13.9333 1.33337 14.6666C1.33337 15.4 1.93337 16 2.66671 16H5.33337V18.6666C5.33337 19.4 5.93337 20 6.66671 20C7.40004 20 8.00004 19.4 8.00004 18.6666V16H10.6667C11.4 16 12 15.4 12 14.6666C12 13.9333 11.4 13.3333 10.6667 13.3333H8.00004ZM20 18.6666C16.44 18.6666 9.33337 20.4533 9.33337 24V25.3333C9.33337 26.0666 9.93337 26.6666 10.6667 26.6666H29.3334C30.0667 26.6666 30.6667 26.0666 30.6667 25.3333V24C30.6667 20.4533 23.56 18.6666 20 18.6666Z",
    fill: "url(#paint0_linear_1540_6805)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1540_6805",
    x1: 16,
    y1: 5.33331,
    x2: 16,
    y2: 26.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720ECF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1540_6805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.42c4d34f0ec3e8090e6b360268c65896.svg";
export { ForwardRef as ReactComponent };